export default __webpack_public_path__ + "static/media/Volleyball.a66814e1.png";